/**
 * This maps backend prop to table column header text.
 */
export const headers = {
    tradeDate: 'Creation Date',
    orderId: 'Op Code',
    portfolioId: 'Portfolio Number',
    accountId: 'Account',
    cifId: 'CIF No',
    rm: 'CTO Code',
    rmGroup: 'Team',
    rmRegion: 'Market',
    operation: 'Operation Status',
    orderType: 'Op Nature',
    orderInitiated: 'Order Initiation',
    instrumentType: 'Instrument Type',
    instrumentSubType: 'Instrument Subtype',
    instrumentCode: 'Instrument Code',
    instrumentName: 'Instrument Name',
    vcStatus: 'VC Status',
    prmAlert: 'PRM Alerts',
    crAlert: 'CR Alerts',
    creationMonth: 'Creation Month',
    s1Rank: 'S1 Rank',
    s1Score: 'S1 Risk Score',
    s2Rank: 'S2 Rank',
    s2Score: 'S2 Risk Score',
    s3Rank: 'S3 Rank',
    s3Score: 'S3 Risk Score',
    s4Rank: 'S4 Rank',
    s4Score: 'S4 Risk Score',
    correlationScore: 'Correlation Risk Score',
    totalScore: 'Total Risk Score',
    revenue: 'Total RM Revenue ($)',
    netDelta: 'Portfolio Unrealized PnL ($)',
    pnl: 'Total PnL ($)',
    marketValue: 'Total Market Value ($)'
};

export const propKeyColumnDictonary = {
    tradeDate: 'trade_date',
    orderId: 'order_id',
    portfolioId: 'portfolio_id',
    accountId: 'account_id',
    cifId: 'cif_id',
    rm: 'rm',
    rmGroup: 'rm_group',
    rmRegion: 'rm_region',
    operation: 'operation',
    orderType: 'order_type',
    orderInitiated: 'order_initiated',
    instrumentType: 'instrument_type',
    instrumentSubType: 'instrument_subtype',
    instrumentCode: 'instrument_code',
    instrumentName: 'instrument_name',
    vcStatus: 'vc_status',
    prmAlert: 'prm_alert',
    crAlert: 'cr_alert',
    creationMonth: 'creation_month',
    s1Rank: 's1_rank',
    s1Score: 's1_score',
    s2Rank: 's2_rank',
    s2Score: 's2_score',
    s3Rank: 's3_rank',
    s3Score: 's3_score',
    s4Rank: 's4_rank',
    s4Score: 's4_score',
    correlationScore: 'correlation_score',
    totalScore: 'total_score',
    revenue: 'revenue',
    netDelta: 'net_delta',
    pnl: 'pl',
    marketValue: 'market_value'
};

export const dataTypes = {
    string: 'VARCHAR',
    number: 'NUMBER',
    currency: 'CURRENCY'
};
